import { slicedToArray as _slicedToArray } from '../../_virtual/_rollupPluginBabelHelpers.js';
import PropTypes from 'prop-types';
import React__default, { useState, useRef, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { useOutsideClick } from '../../hooks/useOutsideClick.js';
import { FadeIn } from '../Animations/FadeIn/FadeIn.js';
import { DEFAULT_PLACEMENT_OPTIONS, DEFAULT_PLACEMENT_OPTION } from './Flyout.constants.js';
import { getCalculatedRelativePlacement } from './Flyout.helper.js';
import { Background, Container } from './Flyout.styles.js';
import { useFlyoutPortalElement } from './FlyoutContext.js';

var Flyout = function Flyout(_ref) {
  var children = _ref.children,
    _ref$disablePointerEv = _ref.disablePointerEvents,
    disablePointerEvents = _ref$disablePointerEv === void 0 ? false : _ref$disablePointerEv,
    _ref$disableScrollWhe = _ref.disableScrollWhenOpen,
    disableScrollWhenOpen = _ref$disableScrollWhe === void 0 ? true : _ref$disableScrollWhe,
    _ref$displayBackdrop = _ref.displayBackdrop,
    displayBackdrop = _ref$displayBackdrop === void 0 ? false : _ref$displayBackdrop,
    _ref$isPortalAlwaysOn = _ref.isPortalAlwaysOnScreen,
    isPortalAlwaysOnScreen = _ref$isPortalAlwaysOn === void 0 ? false : _ref$isPortalAlwaysOn,
    _ref$isPortalClosedOn = _ref.isPortalClosedOnResize,
    isPortalClosedOnResize = _ref$isPortalClosedOn === void 0 ? false : _ref$isPortalClosedOn,
    _ref$offset = _ref.offset,
    offset = _ref$offset === void 0 ? {
      left: 0,
      top: 0
    } : _ref$offset,
    _ref$onOutsideClick = _ref.onOutsideClick,
    onOutsideClick = _ref$onOutsideClick === void 0 ? function () {} : _ref$onOutsideClick,
    _ref$placement = _ref.placement,
    placement = _ref$placement === void 0 ? DEFAULT_PLACEMENT_OPTION : _ref$placement,
    _ref$testId = _ref.testId,
    testId = _ref$testId === void 0 ? undefined : _ref$testId,
    _ref$triggerPosition = _ref.triggerPosition,
    triggerPosition = _ref$triggerPosition === void 0 ? {
      height: 0,
      left: 0,
      top: 0,
      width: 0
    } : _ref$triggerPosition;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    portalDimensions = _useState2[0],
    setPortalDimensions = _useState2[1];
  var ref = useOutsideClick(onOutsideClick);
  var backgroundRef = useRef();
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    position = _useState4[0],
    setPosition = _useState4[1];
  var elementToAttachFlyoutTo = useFlyoutPortalElement();
  useEffect(function () {
    if (position) {
      var _backgroundRef$curren;
      if (!portalDimensions && (backgroundRef === null || backgroundRef === void 0 || (_backgroundRef$curren = backgroundRef.current) === null || _backgroundRef$curren === void 0 ? void 0 : _backgroundRef$curren.children.length) > 0) setPortalDimensions(backgroundRef.current.children[0].getBoundingClientRect());
    }
  }, [position]);
  var handleResize = function handleResize(e) {
    onOutsideClick(e);
  };
  useEffect(function () {
    if (isPortalClosedOnResize) window.addEventListener('resize', handleResize);
    return function () {
      if (isPortalClosedOnResize) window.removeEventListener('resize', handleResize);
    };
  }, []);
  useEffect(function () {
    setPosition(getCalculatedRelativePlacement({
      container: portalDimensions,
      isPortalAlwaysOnScreen: isPortalAlwaysOnScreen,
      offset: offset,
      placement: placement,
      triggerPosition: triggerPosition
    }));
  }, [portalDimensions, placement, triggerPosition.top, triggerPosition.left]);
  useEffect(function () {
    if (disableScrollWhenOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.removeProperty('overflow');
    }
    return function () {
      document.body.style.removeProperty('overflow');
    };
  }, [disableScrollWhenOpen]);
  return ReactDOM.createPortal(React__default.createElement(Background, {
    $isVisible: displayBackdrop,
    $disablePointerEvents: disablePointerEvents,
    "data-testid": testId ? "".concat(testId, "-background") : undefined,
    ref: backgroundRef
  }, React__default.createElement(Container, {
    $top: position === null || position === void 0 ? void 0 : position.top,
    $left: position === null || position === void 0 ? void 0 : position.left,
    "data-testid": testId,
    ref: ref
  }, React__default.createElement(FadeIn, {
    duration: "0.3s"
  }, children))), elementToAttachFlyoutTo);
};
Flyout.propTypes = {
  children: PropTypes.node.isRequired,
  disablePointerEvents: PropTypes.bool,
  disableScrollWhenOpen: PropTypes.bool,
  displayBackdrop: PropTypes.bool,
  isPortalAlwaysOnScreen: PropTypes.bool,
  isPortalClosedOnResize: PropTypes.bool,
  offset: PropTypes.shape({
    left: PropTypes.number,
    top: PropTypes.number
  }),
  onOutsideClick: PropTypes.func,
  placement: PropTypes.oneOf(Object.keys(DEFAULT_PLACEMENT_OPTIONS)),
  testId: PropTypes.string,
  triggerPosition: PropTypes.shape({
    height: PropTypes.number.isRequired,
    left: PropTypes.number.isRequired,
    top: PropTypes.number.isRequired,
    width: PropTypes.number.isRequired
  })
};

export { Flyout };
//# sourceMappingURL=Flyout.js.map
